import { onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router'
import { useUnsavedChangesStore } from '@/stores/unsaved-changes.store'

export function useUnsavedChanges() {
  const store = useUnsavedChangesStore()
  const { isDirty, showConfirmDialog } = storeToRefs(store)

  onBeforeRouteLeave((to) => {
    return store.checkNavigation(to)
  })

  onBeforeRouteUpdate((to) => {
    return store.checkNavigation(to)
  })

  const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    if (isDirty.value) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  window.addEventListener('beforeunload', handleBeforeUnload)
  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload)
    store.clearDirty()
  })

  return {
    isDirty,
    setDirty: store.setDirty,
    setSourceDirty: store.setSourceDirty,
    clearDirty: store.clearDirty,
    showConfirmDialog,
    confirmLeave: store.confirmLeave,
    cancelLeave: store.cancelLeave,
  }
}
